import axios, { Axios } from "axios";
import noAuth from "./api-noAuth";
import api, { baseURL } from "./api";
export default class VendasDigitadasApi {
  static getListaVendasDigitadas = async (
    page: any,
    RecordsPerPage: any,
    Search: any,
    idCliente: number,
    pixDireto: boolean = false
  ) => {
    const response = api.get(
      `/VendaDigitada?Page=${page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&idCliente=${idCliente}&pixDireto=${pixDireto}`
    );
    return response;
  };

  static postVendaDigitada = async (body: any) => {
    const response = await api.post(`/VendaDigitada`, body);
    return response.data;
  };
  static cancelVendaDigitadaPerId = async (id: string) => {
    const response = await api.delete(`/VendaDigitada/${id}/Cancelar`);
    return response.data;
  };

  //Sem token de validação

  static postPayment = async (token: string, body: any) => {
    const response = await fetch("http://api.ipify.org/?format=json");
    const { ip } = await response.json();
    const objeto = { ...body, ip };
    // const response2 = await noAuth.post(
    //   `PagamentoDigitada?token=${token}`,
    //   objeto
    // );
    return objeto;
  };

  static getVendaDigitadaByToken = async (token: string) => {
    const response = await axios.get(
      `${baseURL}/buscarVenda-digitada/token?token=${token}`
    );
    return response.data;
  };

  static senEmailWithLinkForPayment = async (token: any) => {
    const response = await api.get(
      `/VendaDigitada/envio-email/digitada?token=${token}`
    );
    return response.data;
  };
}
